import height from 'dom-helpers/height';
import qsa from 'dom-helpers/querySelectorAll';

/**
 * Truncate text base on container height
 * @param {Element} $target
 * @param clump
 * @param force
 */
export function applyEllipsis($target, clump = 3, force = false) {
    let containerH = height($target);
    let $childTarget = $target.children[0];
    let clumpLine = parseInt($target.getAttribute('data-clump')) || clump;
    let lastTextContent = !force
        ? $target.getAttribute('data-ellapsisText')
        : false;

    if (!$childTarget) {
        return;
    }

    if (lastTextContent) {
        $childTarget.textContent = lastTextContent;
    } else {
        lastTextContent = $childTarget.textContent;
        $target.setAttribute('data-ellapsisText', lastTextContent);
    }

    // skip child that has enough height
    if (
        lastTextContent === '' ||
        (lastTextContent && height($childTarget) <= containerH)
    ) {
        return;
    }

    // remove the last three character until it fit's the container
    let dotApplied = false;
    let max = 100;
    while (height($childTarget) > containerH) {
        if (lastTextContent.length < 5 || max < 1) {
            break;
        }

        // TODO: remove all the special character at the ending?
        lastTextContent = $childTarget.textContent =
            lastTextContent
                .slice(0, lastTextContent.length - clumpLine)
                .trimEnd() + '...';

        //    /\W*\s(\S)*$/
        // add 3 to include 3 dots when slice string
        if (!dotApplied) {
            clumpLine += 3;
            dotApplied = true;
        }

        max--;
    }
}

export function applyTextEllipsisOnResize($targets, clump = 3, force = false) {
    const ioResize = new ResizeObserver((entries, _observer) => {
        entries.forEach(entry => {
            applyEllipsis(entry.target);
        });
    });

    $targets.forEach($el => {
        applyEllipsis($el, clump, force);
        ioResize.observe($el);
    });

    return ioResize;
}

export function applyAndObserveEllipsis($targets) {
    // find all text we want to truncate base on height
    const ioResize = new ResizeObserver((entries, _observer) => {
        entries.forEach(entry => {
            applyEllipsis(entry.target);
        });
    });

    const io = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                ioResize.observe(entry.target);
            } else {
                ioResize.unobserve(entry.target);
            }
        });
    });

    $targets.forEach($el => {
        io.observe($el);
    });

    return {
        ioResize,
        io,
        destroy: () => {
            io.disconnect();
            ioResize.disconnect();
            $targets.forEach($el => $el.removeAttribute('data-ellapsisText'));
        },
    };
}

/**
 * Automatic truncate text base on container height.
 * Note it only truncate element in screen and check using IntersectionObserver
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 *
 * @usage <div class="eb-js-ellipsis"><p class="eb-js-ellipsis"></p></div>
 * @param doc
 */
export default doc => {
    const $targets = qsa(doc, '.eb-js-ellipsis');
    if ($targets.length > 0) {
        applyAndObserveEllipsis($targets);
    }
};
